import { FC, useState } from 'react';
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/components/ui/use-toast";
import { useQueryClient } from '@tanstack/react-query';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const levels = [
  { value: "principiante", label: "Principiante" },
  { value: "intermedio", label: "Intermedio" },
  { value: "avanzado", label: "Avanzado" },
] as const;

interface LessonLevelSelectProps {
  lessonId: string;
  currentLevel: string;
  onUpdate?: () => void;
}

export const LessonLevelSelect: FC<LessonLevelSelectProps> = ({
  lessonId,
  currentLevel = 'principiante',
  onUpdate
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();

  const handleLevelChange = async (newLevel: string) => {
    try {
      setIsLoading(true);
      
      const { error } = await supabase
        .from('lessons')
        .update({ level: newLevel })
        .eq('id', lessonId);

      if (error) throw error;

      await queryClient.invalidateQueries(['lessons']);
      await queryClient.invalidateQueries(['admin-lessons']);
      if (onUpdate) onUpdate();

      toast({
        title: "Nivel actualizado",
        description: `La lección ahora es de nivel ${levels.find(l => l.value === newLevel)?.label.toLowerCase()}`,
      });
    } catch (error) {
      console.error('Error al actualizar el nivel:', error);
      toast({
        title: "Error",
        description: "No se pudo actualizar el nivel de la lección",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Select
      defaultValue={currentLevel}
      onValueChange={handleLevelChange}
      disabled={isLoading}
    >
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Seleccionar nivel" />
      </SelectTrigger>
      <SelectContent>
        {levels.map((level) => (
          <SelectItem
            key={level.value}
            value={level.value}
          >
            {level.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
